module.exports = "/dog-racing/img/jackpot/winner-overlay.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/jackpot/winner-overlay.png
// module id = 269
// module chunks = 7